import React from 'react';
import { useTranslation } from 'react-i18next';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import {
    ALL_REQUEST_RATE_LIMITS,
} from '../../graphql/settings';
import Spinner from '../Spinner';
import Error from '../errors/Error';
import RequestRatesAndLimitsDetailTab from './RequestRatesAndLimitsDetailTab';

function RequestRatesAndLimitsDetail() {
    const { t } = useTranslation();
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(ALL_REQUEST_RATE_LIMITS);
    let result;
    let requestRateLimitProps;
    if (loading) {
        result = <Spinner className="request-rates-and-limits-loading" />;
    } else if (error) {
        result = <Error className="request-rates-and-limits-error" error={error} />;
    } else if (data.allRequestRateLimits.requestRateLimits === null) {
        result = <div className="amqp-not-configured">{t('settings.amqp-not-configured')}</div>;
    } else {
        requestRateLimitProps = {
            availableUsers: data.allRequestRateLimits.availableUsers,
            availableRequestTypes: data.allRequestRateLimits.availableRequestTypes,
            period: data.allRequestRateLimits.period,
            defaultRateLimit: data.allRequestRateLimits.defaultRateLimit,
        };
        result = (
            <RequestRatesAndLimitsDetailTab
                requestRateLimits={data.allRequestRateLimits.requestRateLimits}
                requestRateLimitProps={requestRateLimitProps}
            />
        );
    }
    return result;
}

export default RequestRatesAndLimitsDetail;
